import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './index.css';
import { ContributionAmountResponseDto } from 'enrollment/queries/useContributionAmountQuery';
import { selectPerPayPeriodText } from 'enrollment/services';

interface EmployerContributionProps {
  value: number;
  contributionData: ContributionAmountResponseDto;
}

export const EmployerContribution = ({
  value,
  contributionData,
}: EmployerContributionProps) => {
  const { t } = useTranslation('pages.financial');

  const perPayText = useSelector(selectPerPayPeriodText);

  useEffect(() => {
    const input = document.getElementById(
      'employer-contribution'
    ) as HTMLInputElement;
    if (input) {
      input.value = value.toFixed(2);
    }
  }, [value]);

  return (
    <div className="row mt-2">
      <div className="col-md-5">
        <ps-numeric-field
          input-id="employer-contribution"
          label={t('employer')}
          icon-left
          icon="currency-dollar"
          value={value}
          disabled={true}
          help-text={t('includeAllERContribution', { pppText: perPayText })}
        ></ps-numeric-field>
        <p className="helper-text">
          {t('min')} ${Number(contributionData.data.org_base_amount).toFixed(2) || 0} | {t('max')}
          {' $'}
          {Number(contributionData.data.org_max_amount).toFixed(2) || 0}
        </p>
      </div>
    </div>
  );
};
